module.exports = __webpack_public_path__ + "static/media/hydropurr-3.a45331b5.jpg";